(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const giftWrapCheckbox = document.getElementById('gift-wrap-checkbox');

    if (giftWrapCheckbox) {
      giftWrapCheckbox.addEventListener('change', function () {
        // Prepare form data to update the cart attribute
        const formData = new FormData();
        formData.append('attributes[gift_wrapping]', giftWrapCheckbox.checked ? 'true' : '');

        // Send AJAX request to update the cart
        fetch('/cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          console.log('Gift wrapping attribute updated:', data);
        })
        .catch(error => console.error('Error updating gift wrapping:', error));
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
